// extracted by mini-css-extract-plugin
export default {"wrap":"ZH-z","fullWidth":"_H-z","hideOnDesktop":"aI-z","content":"bI-z","hasOpenedNav":"cI-z","crumbsList":"dI-z","dropdownsWrap":"eI-z"};